// auth/AuthGate.js
import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./LandmarkAuthContext";
import AuthPage from "../components/Blocks/Landmark/AuthPage";

function Loading() {
  return (
    <div className="d-flex justify-content-center align-items-center p-5">
      <div className="spinner-border" role="status" aria-label="Loading" />
    </div>
  );
}

export default function LandmarkAuthGate({ element }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const isSendoraRoute = location.pathname.startsWith("/landmark/sendora");

  if (loading) return <Loading />;
  if (!isAuthenticated) {
    if (isSendoraRoute) {
      return (
        <div className="sendora-auth-gate">
          <AuthPage />
        </div>
      );
    }
    return <AuthPage />;
  }

  return element;
}
